<div class="d-flex external-wrapper">
  <div class="d-flex w-100 loading-container" *ngIf="isUrlIdAvailable && !isError">
    <div>
      <mat-spinner></mat-spinner>
    </div>
    <div class="loading-content">Loading Echo...</div>
  </div>
</div>